import React, { useEffect, useState } from "react";
import { PieChart } from "react-minimal-pie-chart";
import $ from "jquery";
import { convertToTitleCase } from "../../../services/Util";
import Constants from "../../../Constants";
import { Translation } from "react-i18next";
import { useTranslation } from "react-i18next";
export default function Charts(prop) {
  const [pieChartData, setPieChartData] = useState([]);
  const [pieCount, setAllPieCount] = useState([]);
  const {refreshProject }=prop;
  const { t } = useTranslation();
  const translate = t;
  //var size = Object.keys(prop.data?.model).length;
  const colorCode = {
    complete: "#9d2928",
    created: "#ff7253",
    inBidding: "#0bc4d0",
    inReview: "#74bf48",
    completed: "#70BEF5",
    inTranslation: "#26aae0",
  };

  const emptyPieChart = [
    {
      title: "0 created",
      value: 1,
      color: "#f1f1f1",
    },
  ];
  const pieData = [];
  const allData = [];

  const handleClick = (event, segmentIndex) => {
    const clickedSegment = pieChartData[segmentIndex];
    refreshProject(clickedSegment); // Retrieve the value of the clicked segment
  };

  const areaClick = (event, segmentIndex) => {
    if(event.key===Constants.ENTER && !event.shiftKey){
    handleClick(event, segmentIndex);
    }
  };

  useEffect(() => {
    var localCount = 0
    if (prop.data.model !== undefined) {
      Object.keys(prop.data.model).map((item, i) => {
        localCount += prop.data.model[item]
        if (prop.data.model[item] > 0) {
          const translationKey = `campaign_page.${item}`;
          pieData.push({
            title: prop.data.model[item]+ " " + `${translate(translationKey)}`,
            value: prop.data.model[item],
            color: colorCode[item],
            originalName:item
          });
        }
      });
    }
    setPieChartData(pieData);
    setAllPieCount(localCount);
    $('.chartBox path').each((_, item)=>{
      $(item).attr('role', 'link');
    });
    $('#projectsStatus').next().find('svg').attr('aria-labelledby', 'projectsStatus');
  }, [prop]);

  const defaultLabelStyle = {
    fontSize: "4px",
    fontFamily: "sans-serif",
    fill: "#FFFFFF",
  };
  const emptyLabelStyle = {
    fontSize: "0px",
    fill: "#FFFFFF",
  };
  return (
    <div className="flex">
      {prop.projectCount !== 0 ? (
        <>
          
          <div
            className="chartBox"
          >
            <div className="pieTotalCount">
            <span>{pieCount}</span> <strong>{pieCount <= 1 ? 'Project': 'Projects'}</strong>
          </div>
            <PieChart
              radius={35}
              style={{ cursor: 'pointer' }}
              data={pieChartData}
              onClick={handleClick}
              onKeyDown={(e, segmentIndex) => areaClick(e, segmentIndex)}
              segmentsTabIndex={0}
              center={[40, 50]}
              viewBoxSize={[100, 100]}
              lineWidth={40}
              totalValue={pieCount}
              labelPosition={78}
              label={({ dataEntry }) => `${Number.isInteger(dataEntry.percentage)?dataEntry.percentage: dataEntry.percentage?.toFixed(2)} %`}
              labelStyle={{
                ...defaultLabelStyle,
              }}
            />
          </div>
          <div className="clorList">
            <ul>
              {pieChartData.map((d) => {
                return (
                  <li key={d.title}>
                    <span style={{ background: `${d.color}` }}> </span>
                    <small key={d.title}>{d.title}</small>
                  </li>
                );
              })}
            </ul>
          </div>
        </>
      ) : (
        <div className="chartBox" >
          <div className="pieTotalCount">
          <span>{pieCount}</span> <strong>{pieCount <= 1 ? 'Project': 'Projects'}</strong>
          </div>
          <PieChart
            radius={35}
            data={emptyPieChart}
            style={{ cursor: 'pointer' }}
            segmentsTabIndex={0}
            center={[40, 50]}
            viewBoxSize={[100, 100]}
            lineWidth={40}
            totalValue={1}
            onClick={handleClick}
            onKeyDown={(e, segmentIndex) => areaClick(e, segmentIndex)}
            labelPosition={78}
            label={({ dataEntry }) => `${Number.isInteger(dataEntry.percentage)?dataEntry.percentage: dataEntry.percentage?.toFixed(2)} %`}
            labelStyle={{
              ...emptyLabelStyle,
            }}
          />
        </div>
      )}
    </div>
  );
}
